import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';

function destinationFrom(location) {
  const from = location.state?.from;
  return from?.pathname ? `${from.pathname}${from.search ?? ''}` : '/problems';
}

export function RequireAuth() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const signedOut = useAuthStore((state) => state.signedOut);
  const location = useLocation();
  if (!isAuthenticated) return <Navigate to="/login" replace state={signedOut ? undefined : { from: location }} />;
  return <Outlet />;
}

export function GuestOnly() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const [authenticatedOnArrival] = useState(isAuthenticated);
  const location = useLocation();
  const navigate = useNavigate();
  const destination = destinationFrom(location);

  useEffect(() => {
    if (isAuthenticated && !authenticatedOnArrival) navigate(destination, { replace: true, viewTransition: true });
  }, [isAuthenticated, authenticatedOnArrival, destination, navigate]);

  if (authenticatedOnArrival) return <Navigate to="/problems" replace />;
  return <Outlet />;
}
